var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-alert',{attrs:{"type":_vm.alertType,"color":_vm.color,"dense":""}},[_vm._v(" "+_vm._s(_vm.hintNumber)+". "+_vm._s(_vm.text)+" "),_c('span',{staticClass:"redirect-button",on:{"click":_vm.redirectToPath}},[_c('i',{staticClass:"fa fa-arrow-circle-right",staticStyle:{"cursor":"pointer","margin-left":"8px"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }